import styled from 'styled-components';
export const Wrapper = styled.div`
  margin: 10px 0;
`;
